import React from "react";
import Banner from "../components/groomsmen/banner";
import Grooms from "../components/groomsmen/grooms";
import GalFooter from "../components/gallery/gallery-footer";

function GroomsMen() {
  return (
    <>
      <Banner />
      <Grooms />
      <GalFooter />
    </>
  );
}

export default GroomsMen;
